export default __webpack_public_path__ + "static/media/zweytickP.caef30c5.jpg";